export default function Author() {
  return (
    <section
      id="author"
      data-testid="author-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37]/80">
          Behind the book
        </p>
        <h2 className="font-serif-display mt-4 text-4xl sm:text-5xl text-white leading-[1.05] tracking-tight">
          &ldquo;I wrote the playbook I needed at{" "}
          <em className="gold-text">22</em>.&rdquo;
        </h2>

        <div className="mt-10 space-y-5 text-neutral-300 leading-relaxed text-left md:text-center max-w-2xl mx-auto">
          <p>
            Kendrick Callicutt is an entrepreneur, artist and lifelong
            student of self-mastery. After a decade of trial-and-error across
            business, fitness and mindset work, he distilled what{" "}
            <em>actually moves the needle</em> into a 30-day operating system.
          </p>
          <p>
            His work has been used by founders, athletes, students and parents
            — anyone who refuses to settle for the version of themselves that
            showed up yesterday. <em className="gold-text">3x better</em> isn&apos;t a
            tagline. It&apos;s a baseline.
          </p>
        </div>

        {/* Signature */}
        <div className="mt-12 flex flex-col items-center gap-2">
          <div className="font-serif-display italic text-3xl gold-text">
            Kendrick Callicutt
          </div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-neutral-500">
            Author · 30 Days of Growth
          </div>
        </div>

        {/* Stats */}
        <div className="mt-14 grid grid-cols-3 gap-6 max-w-xl mx-auto">
          {[
            { n: "12K+", l: "Readers" },
            { n: "47", l: "Countries" },
            { n: "30", l: "Day system" },
          ].map((s, i) => (
            <div key={i} className="border-l border-[#d4af37]/30 pl-4 text-left">
              <div className="font-serif-display text-3xl gold-text">
                {s.n}
              </div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-neutral-500 mt-1">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
